/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { Notification } from '../../data/types';

export type NotificationState = {
    notifications: Notification[],
}

export const useNotificationState = () => {
    const notificationState = useSelector((state: RootState | any) => state.notifications as NotificationState);
    return notificationState;
}

// Define the initial state using that type
const initialState: NotificationState = {
    notifications: [],
}

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState: initialState,
    reducers: {
        setNotificationsAction: (state, action: PayloadAction<Notification[]>) => {
            state.notifications = action.payload;
        },
        addOrReplaceNotificationAction: (state, action: PayloadAction<Notification>) => {
            const existingIndex = (state.notifications || []).findIndex((notification: Notification) => !!notification && notification.notificationId === action.payload.notificationId);
            if (existingIndex !== undefined && existingIndex >= 0) {
                state.notifications[existingIndex] = action.payload;
            } else {
                state.notifications.push(action.payload);
            }
        },
        markNotificationsViewedAction: (state, action: PayloadAction<string[]>) => {
            state.notifications = state.notifications.map(n => action.payload.includes(n.notificationId as string) ? { ...n, viewedOn: new Date() } : n);
        },
        deleteNotificationAction: (state, action: PayloadAction<string>) => {
            state.notifications = state.notifications.filter((x) => x.notificationId !== action.payload);
        },
        deleteNotificationsAction: (state, action: PayloadAction<string[]>) => {
            state.notifications = state.notifications.filter((x) => x.notificationId && !action.payload.includes(x.notificationId));
        },
    }
})

export const { addOrReplaceNotificationAction, setNotificationsAction, markNotificationsViewedAction, deleteNotificationAction, deleteNotificationsAction } = notificationSlice.actions;

export default notificationSlice.reducer;